// extracted by mini-css-extract-plugin
export var moduleContainer = "lottie-module--moduleContainer--26f1a";